import React from 'react';

import { Typography, Button } from '@mui/material';

type Props = {
  isDisabled: boolean;
  onClick: () => void;
};

const LookupCodeButton: React.FC<Props> = ({ isDisabled, onClick }) => {
  return (
    <Button
      disabled={isDisabled}
      onClick={onClick}
      variant='contained'
      color='darkBlue'
      sx={{
        borderRadius: '40px',
        height: '40px',
        padding: '0 20px',
      }}
      disableElevation
    >
      <Typography color='#ffffff'>Add / Lookup</Typography>
    </Button>
  );
};

export default LookupCodeButton;
